import { NOTIFICATIONS_FETCH_SUCCESS, NOTIFICATIONS_FETCH_RESET } from '../actions/types';

const INIT_STATE = {
  notifications: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case NOTIFICATIONS_FETCH_SUCCESS: {
      return {
        ...state,
        notifications: action.payload,
      };
    }
    case NOTIFICATIONS_FETCH_RESET: {
      return {
        ...state,
        notifications: [],
      };
    }
    default:
      return state;
  }
};
